function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import ImageItem from '../imageItem';

var VideoItemPlaceholder = /*#__PURE__*/function (_ImageItem) {
  _inheritsLoose(VideoItemPlaceholder, _ImageItem);

  function VideoItemPlaceholder(props) {
    return _ImageItem.call(this, props) || this;
  }

  var _proto = VideoItemPlaceholder.prototype;

  _proto.render = function render() {
    var videoControls = this.props.videoControls;
    var VideoPlaceholderContainerClassnames = this.getImageContainerClassNames() + ' video-item gallery-item-video';
    var videoPlaceholderImageRenderer = this.getImageElement();
    var renderedItem = this.getImageContainer(videoPlaceholderImageRenderer, VideoPlaceholderContainerClassnames, videoControls);
    return renderedItem;
  };

  return VideoItemPlaceholder;
}(ImageItem);

export default VideoItemPlaceholder;